import { CanaisBento } from '~/components/marketing/canais-bento'
import { EntregaveisBento } from '~/components/marketing/entregaveis-bento'
import { FaqSection } from '~/components/marketing/faq-section'
import { FeatureRowsSection } from '~/components/marketing/feature-rows-section'
import { FunnelBento } from '~/components/marketing/funil-bento'
import { HeroSection } from '~/components/marketing/hero-section'
import { LanguageBanner } from '~/components/marketing/language-banner'
import { MarketingFooter } from '~/components/marketing/marketing-footer'
import { MarketingNav } from '~/components/marketing/marketing-nav'
import { PricingSection } from '~/components/marketing/pricing-section'
import { ProblemSection } from '~/components/marketing/problem-section'
import { ProductIconsSection } from '~/components/marketing/product-icons-section'
import { TrabalhoBento } from '~/components/marketing/trabalho-bento'
import { MarketingLocaleProvider } from '~/lib/marketing-locale'
import '~/styles/marketing.css'

/*
 * Homepage (pt-BR). Tight narrative now — each module group is a single bento
 * that links to its own /recursos/<slug> page for the full deep dive (IA
 * included, via /recursos/ia).
 *
 * The English homepage is a separate composition, not a translation of this
 * one — see `src/components/marketing/en/en-home-page.tsx`.
 */
export const MarketingHomePage = () => {
  return (
    <MarketingLocaleProvider locale="pt-BR">
      <div className="mkt-site min-h-screen bg-white font-sans text-[#0b0b0d] antialiased [text-rendering:optimizeLegibility]">
        <LanguageBanner />
        <MarketingNav />
        <main>
          <HeroSection />
          <ProductIconsSection />
          <ProblemSection />
          <FeatureRowsSection />

          {/* Group bentos — each compact, each linking to a subpage */}
          <FunnelBento />
          <TrabalhoBento />
          <EntregaveisBento />

          {/* WhatsApp, in its own band. No subpage. */}
          <CanaisBento />

          <FaqSection />
          <PricingSection />
        </main>
        <MarketingFooter />
      </div>
    </MarketingLocaleProvider>
  )
}
